import { useTranslation } from 'utils/use-translation'

import { goToChat } from 'utils/go-to-chat'

import cn from 'classnames'

import ButtonWhite from 'components/ui/button/_color/_white'

import ButtonBlue from '../../../../button/_color/_blue'

import Popup from '../../../popup'

import { IKycPopupProps } from './kyc-popup.props'
import KYCIcon from './images/kyc.svg'

import styles from './styles.module.scss'

export default function KYCPopup({
  setIsOpened,
  title,
  subtitle,
  text,
  onClick,
  buttonText,
  className,
  whiteButtonText,
  whiteButtonOnClick,
  icon,
}: IKycPopupProps) {
  const { t } = useTranslation()

  return (
    <Popup
      containerClassname={cn(styles.popup, className)}
      heading={title ?? t('kyc_check_required')}
      subtitle={subtitle ?? t('action_needed_loan')}
      headerClassname={styles.header}
      subtitleClassname={styles.subtitle}
      onClose={() => setIsOpened(false)}
    >
      <div className={styles.main}>
        <img src={icon ?? KYCIcon} alt="KYC Icon" />
        <p className={styles.text}>{text ?? t('unable_process_loan')}</p>
      </div>

      <div className={styles.buttons}>
        {whiteButtonText && (
          <ButtonWhite className={styles.btn__white} onClick={whiteButtonOnClick || goToChat}>
            {whiteButtonText || t('contact_support')}
          </ButtonWhite>
        )}

        <ButtonBlue onClick={onClick || goToChat} className={styles.btn}>
          {buttonText || t('contact_support')}
        </ButtonBlue>
      </div>
    </Popup>
  )
}
